export interface FederatedUser {
    name: string,
    email?: string
}